import React from 'react';
import styled from 'styled-components';
import { Box, Button, Stack, SubtleText } from '@99designs/emu';
import { PackagePrice } from '../PackagePrice';
import type { Price as PriceType } from '../../types';

type CTAProps = {
    key?: string;
    href: string;
    ref?: React.Ref<HTMLButtonElement>;
    onClick?: (e: React.MouseEvent) => void;
};

export interface CheckoutSummaryProps {
    pricing?: PriceType;
    cta: CTAProps;
    secondaryCta?: CTAProps;
    showAltCta?: boolean;
    altCtaText?: string;
}

const StyledSubtleText = styled(SubtleText)`
    text-align: center;
`;

export function CheckoutSummary({
    pricing,
    cta,
    secondaryCta,
    showAltCta,
    altCtaText,
}: CheckoutSummaryProps) {
    return (
        <Stack space="1bu">
            {pricing && <PackagePrice price={pricing} />}
            <Button
                key={cta.key}
                ref={cta.ref}
                href={cta.href}
                onClick={cta.onClick}
                width="fill"
                size="medium"
                disabled={!pricing}
            >
                {showAltCta ? altCtaText : __('Continue to brief')}
            </Button>

            {secondaryCta && (
                <Button
                    key={secondaryCta.key}
                    ref={secondaryCta.ref}
                    href={secondaryCta.href}
                    width="fill"
                    size="medium"
                    appearance="tertiary"
                    openInNewTab
                >
                    {__('Talk to us')}
                </Button>
            )}
            {pricing && (
                <Box display="flex" flexDirection="column" alignItems="center">
                    <StyledSubtleText>{__("You won't be charged yet.")}</StyledSubtleText>
                    <StyledSubtleText>
                        {__('Additional local tax may apply and will be calculated at checkout.')}
                    </StyledSubtleText>
                </Box>
            )}
        </Stack>
    );
}
